/**
 * A small, dismissible banner shown when we've fallen back to WebGL2.
 * Non-blocking by design (see plan, Phase 0 exit check): the scene still
 * renders on WebGL2, this just sets expectations about visual quality.
 */
export function showWebGL2FallbackNotice(): void {
  const banner = document.createElement("div");
  banner.setAttribute("role", "status");
  banner.style.cssText = `
    position: fixed;
    left: 50%;
    bottom: 24px;
    transform: translateX(-50%);
    z-index: 10;
    background: rgba(10, 14, 22, 0.85);
    color: #e8edf5;
    font: 13px/1.4 system-ui, sans-serif;
    padding: 10px 16px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.12);
    max-width: min(520px, 90vw);
    backdrop-filter: blur(6px);
  `;
  banner.textContent =
    "WebGPU isn't available in this browser — running on the WebGL2 fallback. " +
    "For the full-quality renderer, try a recent Chrome or Edge.";

  const dismiss = document.createElement("button");
  dismiss.textContent = "Dismiss";
  dismiss.style.cssText = `
    margin-left: 12px;
    background: transparent;
    color: #9db4d8;
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 4px;
    padding: 2px 8px;
    cursor: pointer;
    font: inherit;
  `;
  dismiss.onclick = () => banner.remove();
  banner.appendChild(dismiss);

  document.body.appendChild(banner);
}
